export default __webpack_public_path__ + "static/media/secondary.cb1b129422e55897b941cb0f3b1e87be.svg";